import InnerComponent from '@Components/Settings/WarehouseSetup';
import orgContainer from '@Components/AppContainer';

const WarehouseSetup = () => ((orgContainer(InnerComponent)));
export default WarehouseSetup;
